"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("@jobmatchme/ui/es/components/Button"));

var _useOurTranslation = _interopRequireDefault(require("../../../../../../utils/useOurTranslation"));

var _google = _interopRequireDefault(require("./images/google.svg"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

/**
 * The google social button
 * @param {Function} callback // The callback for the button
 */
var GoogleBtn = function GoogleBtn(_ref) {
  var callback = _ref.callback;
  var t = (0, _useOurTranslation.default)('profile-components:SocialLogin.SocialButton');
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Button.default, {
    id: "app-google-btn",
    htmlType: "button",
    size: "small",
    color: "white",
    className: "".concat(_styleModule.default.googleBtn, " ").concat(_styleModule.default.socialBtn),
    onClick: callback,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      alt: "Google icon",
      className: _styleModule.default.googleIcon,
      src: _google.default
    }), t('button')]
  });
};

var _default = GoogleBtn;
exports.default = _default;